<template>
  <van-overlay :show="show" @click="show = false">
    <div :class="`feedback-wrapper-${deparment}`">
      <div class="content" v-if="deparment === 'tutor'">
        <img
          v-if="status === 'success'"
          src="../../public/img/feedback-success.png"
          alt="feedback-success"
        />
        <img
          v-else
          src="../../public/img/feedback-error.png"
          alt="feedback-error"
        />
        <p class="title">{{ title }}</p>
        <p class="info">{{ content }}</p>
        <slot />
      </div>
      <div class="content" v-else>
        <p class="title">
          <img
            class="img"
            v-if="status === 'success'"
            src="../../public/img/success-zebra.png"
            alt="feedback-success"
          />
          <img
            class="img"
            v-else
            src="../../public/img/error-zebra.png"
            alt="feedback-error"
          />
          <span :class="`tit tit-${status}`">{{ title }}</span>
        </p>
        <p class="info">{{ content }}</p>
        <slot />
      </div>
    </div>
  </van-overlay>
</template>
<script>
export default {
  props: {
    deparment: String,
  },
  data() {
    return {
      show: false,
      status: '',
      title: '',
      content: '',
    }
  },
  created() {
    this.$bus.$on('feedbackModal', data => {
      this.status = data.status
      this.title = data.title
      this.content = data.content
      this.show = true
    })
  },
  beforeDestroy() {
    this.$bus.$off('feedbackModal')
  },
}
</script>
<style lang="less" scoped>
.feedback-wrapper-tutor {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .content {
    max-width: 436px;
    width: 58.13vw;
    background-color: #fff;
    border-radius: 5%;
    text-align: center;
    min-height: 277px;
    padding-bottom: 20px;
    img {
      width: 60%;
      margin: 24px auto 21px;
    }
    .title {
      font-size: 18px;
      color: #333;
      font-weight: 600;
      line-height: 25px;
      margin-bottom: 10px;
    }
    .info {
      font-size: 13px;
      color: #8c8c8c;
      line-height: 20px;
      padding: 0 16px;
    }
  }
}
.feedback-wrapper-zebra {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .content {
    // max-width: 436px;
    width: 84%;
    background-color: #fff;
    border-radius: 10.5px;
    text-align: center;
    padding-bottom: 30px;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0;
      .img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
      .tit {
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
      }
      .tit-success {
        color: #34c83f;
      }
      .tit-error {
        color: #f55d5d;
      }
    }
    .info {
      font-size: 16px;
      color: #333;
      line-height: 22px;
      margin: 0 30px 0;
    }
  }
}
</style>
